module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui card",
    class: {
      hasalert: (_vm.wdSorted['red'].length > 0 || _vm.wdSorted['mute'].length > 0),
      stts21kdfslds: (_vm.wd.status == 21)
    },
    attrs: {
      "data-wdtype": _vm.wdtype
    },
    on: {
      "mouseover": function($event) {
        return _vm.hoverState(true)
      },
      "mouseleave": _vm.handleMouseLeave,
      "mouseenter": _vm.handleMouseEnter,
      "mousemove": _vm.handleMouseMove
    }
  }, [(_vm.showSuppressedMsg && _vm.isSuppressed) ? _c('div', {
    staticClass: "suppressed-tooltip",
    style: ({
      top: _vm.tooltipY + 'px',
      left: _vm.tooltipX + 'px'
    })
  }, [_vm._v("\n       Upgrade your plan to unlock this alert and access all 25+ critical notifications\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content",
    class: {
      'greyed-out-card': _vm.isSuppressed
    }
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "text-shadow": "1px 1px 2px #DDD",
      "font-size": "24px"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newAlertCount > 0),
      expression: "newAlertCount>0"
    }],
    staticClass: "ui red horizontal label",
    staticStyle: {
      "text-shadow": "none",
      "padding": "5px 6px 4px",
      "margin": "-21px",
      "position": "absolute"
    }
  }, [_vm._v(_vm._s(_vm.newAlertCount) + " new")]), _vm._v(" "), _c('i', {
    class: (_vm.wd.status === 0 ? 'green' : 'orange') + ' power icon'
  }), _vm._v("\n\n      " + _vm._s(_vm.wdInfo[_vm.wdtype].name) + "\n      "), (_vm.wd.status === 20) ? _c('span', [_vm._v("[preview]")]) : _vm._e(), _vm._v("\n\n       "), (_vm.isConfigurable) ? _c('a', {
    staticStyle: {
      "color": "steelblue",
      "font-size": "small",
      "font-weight": "normal",
      "text-shadow": "none"
    },
    on: {
      "click": function($event) {
        _vm.showConfiguration = !_vm.showConfiguration
      }
    }
  }, [_c('i', {
    staticClass: "cogs icon"
  }), _vm._v("Configure\n      ")]) : _vm._e()]), _vm._v(" "), _c('small', {
    staticClass: "cchfreq"
  }, [_vm._v(" current check frequency: " + _vm._s(_vm.wdInfo[_vm.wdtype].ccf) + " ")]), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off",
      "onsubmit": "return false;"
    }
  }, [(!_vm.accountLevelWd) ? _c('div', {
    staticClass: "ui mini right icon input",
    staticStyle: {
      "position": "absolute",
      "top": "38px",
      "right": "15px"
    }
  }, [_c('div', {
    staticClass: "ui mini floating dropdown labeled icon button",
    style: (_vm.currentTab !== 1 ? 'display : none' : null)
  }, [_c('i', {
    staticClass: "filter icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Filter")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (!_vm.accountLevelWd) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterString),
      expression: "filterString"
    }, {
      name: "prevent-autofill",
      rawName: "v-prevent-autofill",
      value: (_vm.filterString),
      expression: "filterString"
    }],
    staticStyle: {
      "padding": "4px"
    },
    style: (_vm.filterString ? 'background-color:lightsalmon;border:1px solid orange;' : ''),
    attrs: {
      "type": "search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.filterString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterString = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "search icon"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'muteRingAni': _vm.muteRingAni
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wdTabControls"
  }, [_vm._l((_vm.tabsToDisplay), function(x, i) {
    return _c('a', {
      class: 'ui small label ' + (_vm.currentTab == i ? _vm.wdl[x].color + ' actvtb' : '') + (_vm.wdSorted[x].length > 0 ? '' : ' disabled'),
      attrs: {
        "data-html": _vm.wdl[x].blurb,
        "data-variation": "inverted mini",
        "data-position": _vm.wdl[x].bpos
      },
      on: {
        "click": function($event) {
          return _vm.setCurrentTab(i)
        }
      }
    }, [_c('i', {
      class: _vm.wdl[x].icon + ' icon ' + (_vm.currentTab != i ? _vm.wdl[x].color : '') + (_vm.wdSorted[x].length == 0 && (x == 'red' || x == 'amber') ? ' outline' : '')
    }), _vm._v("\n         " + _vm._s(_vm.wdSorted[x].length) + "\n      ")])
  }), _vm._v(" "), _c('a', {
    class: 'ui small label ' + (_vm.currentTab == 99 ? 'grey actvtb' : ''),
    on: {
      "click": function($event) {
        return _vm.setCurrentTab(99)
      }
    }
  }, [_vm._v("info 1")]), _vm._v(" "), (_vm.$parent.$parent.onboarding.wdtabs) ? _c('div', {
    staticClass: "onboarding ui left pointing large yellow label",
    staticStyle: {
      "position": "absolute",
      "padding-bottom": "9px",
      "margin-top": "4px",
      "z-index": "11"
    },
    attrs: {
      "data-onboarding": "wdtabs"
    }
  }, [_vm._v("\n        These are Tabs! - "), _c('small', [_vm._v("Click any of them to dismiss this note")])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeLeft"
    }
  }, [_c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newAlertCount > 0 && _vm.currentTab == 1),
      expression: "newAlertCount>0&&currentTab==1"
    }],
    staticClass: "markAllSeen",
    on: {
      "click": function($event) {
        return _vm.markAllSeen(_vm.wdtype)
      }
    }
  }, [(_vm.markAllSeenInProgress) ? _c('i', {
    staticClass: "black tight notched circle loading icon"
  }) : _vm._e(), _vm._v("\n        [mark all new as seen]\n      ")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "wdTabCwrap"
  }, [_c('div', {
    staticClass: "shadow-top",
    class: {
      active: _vm.topShader
    }
  }), _vm._v(" "), _c('div', {
    class: 'wdTabC ui ' + (_vm.currentTab == 99 ? 'grey' : _vm.wdl[_vm.tabsToDisplay[_vm.currentTab]].color) + ' basic segment',
    style: (_vm.setWDCHeight()),
    on: {
      "mousewheel": _vm.fixScrolling,
      "scroll": _vm.setInnerShaders
    }
  }, [_c('transition', {
    attrs: {
      "name": "fadeLeft",
      "mode": "out-in"
    }
  }, [(_vm.showConfiguration && _vm.wdtype == 'amazonChoiceBadge') ? _c('AmazonChoiceBadgeConfig') : _vm._e(), _vm._v(" "), (_vm.showConfiguration && _vm.wdtype == 'starRatingRecentChange') ? _c('StarRatingRecentChangeConfig') : _vm._e(), _vm._v(" "), (_vm.showConfiguration && _vm.wdtype == 'productCategoryRecentChange') ? _c('CategoryChangeConfig') : _vm._e(), _vm._v(" "), (_vm.showConfiguration && _vm.wdtype == 'bestSellerBadge') ? _c('BestSellerBadgeConfig') : _vm._e(), _vm._v(" "), (_vm.showConfiguration && _vm.wdtype == 'listingSuspended') ? _c('ListingSuspendedConfig') : _vm._e(), _vm._v(" "), (_vm.showConfiguration && _vm.wdtype == 'subscribeAndSave') ? _c('SubscribeAndSaveConfig') : _vm._e(), _vm._v(" "), (_vm.showConfiguration && _vm.wdtype == 'parentProductChange') ? _c('ParentProductChangeConfig') : _vm._e(), _vm._v(" "), (_vm.showConfiguration && _vm.wdtype == 'inventory') ? _c('SpreadsheetConfig', {
    attrs: {
      "watch-dog-name": 'FBA Stock',
      "api-prefix": 'inventory'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showConfiguration && _vm.wdtype == 'fbmInventory') ? _c('SpreadsheetConfig', {
    attrs: {
      "watch-dog-name": 'FBM Stock',
      "api-prefix": 'fbm_inventory'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showConfiguration && _vm.wdtype == 'salesDrop') ? _c('SpreadsheetConfig', {
    attrs: {
      "watch-dog-name": 'Sales Volume',
      "api-prefix": 'salesdrop'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showConfiguration && _vm.wdtype == 'productDetailsRecentChange') ? _c('ProductDetailsRecentChangeConfig') : _vm._e(), _vm._v(" "), (_vm.showConfiguration && _vm.wdtype == 'fbaFeeChange') ? _c('FBAFeeChangeConfig') : _vm._e(), _vm._v(" "), (_vm.showConfiguration && (_vm.wdtype == 'numberOfSellers' || _vm.wdtype == 'lostBuybox')) ? _c('StoreFrontWhiteListConfig', {
    attrs: {
      "watchDogType": _vm.wdtype
    }
  }) : (_vm.currentTab == 99) ? _c('div', {
    key: "99",
    staticClass: "ui grid"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('div', {
    staticClass: "ui center aligned basic segment badges",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('a', {
    staticClass: "ui green tiny statistic",
    on: {
      "click": function($event) {
        _vm.currentTab = 0
      }
    }
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.wdSorted.ok.length))]), _c('div', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "green check icon"
  }), _vm._v("OK")])]), _vm._v(" "), _c('a', {
    staticClass: "ui red tiny statistic",
    on: {
      "click": function($event) {
        _vm.currentTab = 1
      }
    }
  }, [_c('div', {
    staticClass: "value"
  }, [_c('i', {
    staticClass: "exclamation icon"
  }), _vm._v(" " + _vm._s(_vm.wdSorted.red.length) + " ")]), _c('div', {
    staticClass: "label"
  }, [_vm._v("Issues")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wdSorted.mute.length > 0),
      expression: "wdSorted.mute.length>0"
    }],
    staticClass: "ui blue tiny statistic",
    on: {
      "click": function($event) {
        _vm.currentTab = 2
      }
    }
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.wdSorted.mute.length))]), _c('div', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "mute alarm outline icon"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "nine wide column"
  }, [_c('div', {
    staticClass: "ui center aligned basic very padded segment",
    staticStyle: {
      "margin-top": "30px",
      "min-height": "150px",
      "border": "1px solid #eee",
      "border-radius": "6px"
    }
  }, [_c('span', {
    staticClass: "ui left corner label"
  }, [_c('i', {
    staticClass: "info circle icon"
  })]), _vm._v("\n             " + _vm._s(_vm.wdInfo[_vm.wdtype].desc) + "\n          ")])])]) : (_vm.currentTab !== 99) ? _c('div', {
    key: _vm.currentTab,
    staticClass: "ui list"
  }, [(_vm.wdSorted[_vm.tabsToDisplay[_vm.currentTab]].length == 0) ? _c('div', [_vm._v("\n                 \n          "), (_vm.tabsToDisplay[_vm.currentTab] == 'ok') ? _c('span', [_vm._v("No items to show")]) : _vm._e(), _vm._v(" "), (_vm.tabsToDisplay[_vm.currentTab] == 'red' && _vm.wdSorted.red.length == 0) ? _c('span', [_vm._v("No current Alerts")]) : _vm._e(), _vm._v(" "), (_vm.tabsToDisplay[_vm.currentTab] == 'mute') ? _c('span', [_vm._v("No Muted alerts or Alerts marked as Done")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.filterString !== '' || _vm.filterCategory !== '') ? _c('div', [(_vm.filteredResults(_vm.wdSorted[_vm.tabsToDisplay[_vm.currentTab]]).length == 0) ? _c('span', [_vm._v("No items match your filter, try a different one.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.paginatedItems), function(item) {
    return _c('WatchdogItem', {
      key: item.watchDogItemId,
      attrs: {
        "item": item,
        "itemtype": _vm.tabsToDisplay[_vm.currentTab],
        "itemprops": _vm.wdl[_vm.tabsToDisplay[_vm.currentTab]],
        "wdtype": _vm.wdtype,
        "groupByParent": _vm.groupByParent,
        "detSel": _vm.detSel
      },
      on: {
        "muteRingAni": _vm.doMuteRingAni
      }
    })
  }), _vm._v(" "), (_vm.totalPages > 1) ? _c('div', {
    staticClass: "ui center aligned segment",
    staticStyle: {
      "margin": "10px 0",
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "ui mini pagination menu"
  }, [_c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.currentPage === 0
    },
    on: {
      "click": _vm.prevPage
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  })]), _vm._v(" "), _vm._l((Math.min(5, _vm.totalPages)), function(page) {
    return _c('a', {
      key: page,
      staticClass: "item",
      class: {
        active: _vm.currentPage === _vm.getPageNumber(page)
      },
      on: {
        "click": function($event) {
          _vm.goToPage(_vm.getPageNumber(page))
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.getPageNumber(page) + 1) + "\n            ")])
  }), _vm._v(" "), _c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.currentPage >= _vm.totalPages - 1
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_c('i', {
    staticClass: "right chevron icon"
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "ui mini message",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("\n            Showing page " + _vm._s(_vm.currentPage + 1) + " of " + _vm._s(_vm.totalPages) + "\n            (" + _vm._s(_vm.totalItems) + " total items)\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.tabsToDisplay[_vm.currentTab] == 'red' && _vm.wdSorted.mute.length > 0) ? _c('a', {
    key: "rndmkey349857",
    staticClass: "item",
    on: {
      "click": function($event) {
        _vm.currentTab = 2
      }
    }
  }, [_c('i', {
    staticClass: "right blue warning icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "description"
  }, [((_vm.wdSorted.mute.length - _vm.muteCount) > 0) ? _c('span', [_vm._v("\n                You " + _vm._s(_vm.wdSorted.red.length > 0 ? 'also' : '') + " have "), _c('strong', [_vm._v(_vm._s(_vm.wdSorted.mute.length - _vm.muteCount))]), _vm._v(" issue" + _vm._s(_vm.wdSorted.mute.length > 1 ? 's' : '') + " marked as Done.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.muteCount > 0) ? _c('span', [_vm._v("\n                  "), _c('strong', [_vm._v(_vm._s(_vm.muteCount))]), _vm._v(" product" + _vm._s(_vm.muteCount > 1 ? 's' : '') + " on Mute.\n              ")]) : _vm._e()])])]) : _vm._e()], 2) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "shadow-bottom",
    class: {
      active: _vm.bottomShader
    }
  })]), _vm._v(" "), (false && !_vm.accountLevelWd) ? _c('div', {
    staticClass: "extra content"
  }, [(_vm.isConfigurable) ? _c('div', {
    staticStyle: {
      "width": "160px",
      "float": "left"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.showConfiguration = !_vm.showConfiguration
      }
    }
  }, [_c('i', {
    staticClass: "cogs icon"
  }), _vm._v("Configure")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui mini left icon input",
    staticStyle: {
      "margin": "-5px 0px -5px 5px",
      "float": "right"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterString),
      expression: "filterString"
    }, {
      name: "prevent-autofill",
      rawName: "v-prevent-autofill",
      value: (_vm.filterString),
      expression: "filterString"
    }],
    attrs: {
      "type": "search",
      "placeholder": "Filter results..."
    },
    domProps: {
      "value": (_vm.filterString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterString = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "filter icon"
  })]), _vm._v(" "), _c('b', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filterString),
      expression: "filterString"
    }],
    staticStyle: {
      "color": "orange",
      "float": "right"
    }
  }, [_vm._v("Current filter:")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n              Filter by issue status\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "1"
    }
  }, [_c('i', {
    staticClass: "unhide icon"
  }), _vm._v("\n              Seen\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "2"
    }
  }, [_c('i', {
    staticClass: "time icon"
  }), _vm._v("\n              In progress\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n              Filter by alert type\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "3"
    }
  }, [_c('i', {
    staticClass: "orange circle icon"
  }), _vm._v("\n              Warning\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "4"
    }
  }, [_c('i', {
    staticClass: "red circle icon"
  }), _vm._v("\n              Alert\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27a19c1c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Watchdog.vue
// module id = 736
// module chunks = 2